import PreEvaluationDetails from './View/PreEvaluationDetails.view';
export default PreEvaluationDetails;
